"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const Info_1 = __importDefault(require("@mui/icons-material/Info"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const react_uid_1 = require("react-uid");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const useDebounceFunction_1 = __importDefault(require("../../../common/helpers/Hooks/useDebounceFunction"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const SearchListItem_1 = __importDefault(require("./SearchListItem"));
const ActivitiSearchListItems_1 = __importDefault(require("./ActivitiSearchListItems"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const SearchWrapper = styled_components_1.default.div `
  .text-field {
    width: 100%;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.06);
    font-size: 0.875rem;

    @media (min-width: 900px) {
      background-color: rgba(0, 0, 0, 0.06);
      border-radius: 8px;
    }

    .MuiInputBase-adornedStart {
      &:before,
      &:after {
        border-bottom: none !important;
      }
    }

    & > div {
      padding: 0 12px;

      input {
        padding: 10px 5px;
        font-size: 1rem;
      }

      // this is used to get rid of the blue color when clicking on autocomplete in Chromium browsers
      input:-webkit-autofill,
      input:-webkit-autofill:focus {
        transition:
          background-color 600000s 0s,
          color 600000s 0s;
      }

      .close-button {
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }
`;
const ListItemWrapper = styled_components_1.default.ul `
  margin: 0 16px;

  & > div {
    margin-bottom: 15px;
  }
`;
const TypeName = styled_components_1.default.p `
  margin: 0;

  .accordion-title {
    color: rgba(0, 0, 0, 87%);
  }
`;
const SearchResults = styled_components_1.default.div `
  margin-top: 12px;

  .Mui-disabled {
    background-color: #fff;
  }
`;
const NoSearchResults = styled_components_1.default.div `
  text-align: center;
  margin-top: 100px;

  svg {
    fill: black;
  }

  .info-icon-wrapper {
    border-radius: 50%;
    height: 70px;
    width: 70px;
    display: inline-grid;
    place-content: center;
    background-color: rgba(0, 39, 61, 0.12);
  }
`;
const MIN_CHARACTER_LIMIT = 3;
const Search = ({ collection, unfilteredActivities, directoryData, offers, onClose, navigations, }) => {
    const [searchTerm, setSearchTerm] = (0, react_1.useState)("");
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [filteredActivities, setFilteredActivities] = (0, react_1.useState)([]);
    const [filteredOffers, setFilteredOffers] = (0, react_1.useState)([]);
    const [filteredDirectories, setFilteredDirectories] = (0, react_1.useState)([]);
    const activitiesRef = (0, react_1.useRef)([]);
    const offersRef = (0, react_1.useRef)([]);
    const directoriesRef = (0, react_1.useRef)([]);
    const prepareNodes = (nodes, mainType, isActivity = false) => {
        const stack = [...nodes];
        while (stack.length) {
            const node = stack.shift();
            const nodeKey = node && Object.keys(node)[0];
            const nodeContent = !isActivity ? node[nodeKey] : node;
            const nodeType = nodeContent && nodeContent.type;
            if (nodeType) {
                if (mainType === "activities") {
                    activitiesRef.current.push(nodeContent);
                }
                if (mainType === "offers") {
                    offersRef.current.push(nodeContent);
                }
                if (mainType === "directories") {
                    directoriesRef.current.push(nodeContent);
                }
            }
            if (nodeType === "folder" && nodeContent.children) {
                prepareNodes(nodeContent.children, mainType);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (!collection &&
            unfilteredActivities &&
            unfilteredActivities.length > 0) {
            prepareNodes(unfilteredActivities, "activities", true);
        }
    }, [unfilteredActivities]);
    (0, react_1.useEffect)(() => {
        if (!collection && directoryData && directoryData.length > 0) {
            prepareNodes(directoryData, "directories");
        }
    }, [directoryData]);
    (0, react_1.useEffect)(() => {
        if (!collection && offers && offers.length > 0) {
            prepareNodes(offers, "offers");
        }
    }, [offers]);
    // used for searching inside a collection, we might want this functionality in the future
    // useEffect( () => {
    //     if ( collection && collection.length > 0 ) {
    //         // we need this to reset the array when collection changes
    //         // prepareNodes( collection );
    //     }
    // }, [ collection ] );
    const stripHtmlTags = (text) => text.replace(/<\/?[^>]+(>|$)/g, "");
    const debouncedRequest = (0, useDebounceFunction_1.default)(() => {
        if (searchTerm.length >= MIN_CHARACTER_LIMIT) {
            const filteredActivitiesTemp = activitiesRef.current.filter((item) => {
                const textWithoutTags = stripHtmlTags(item.text);
                return textWithoutTags.toLowerCase().includes(searchTerm.toLowerCase()) || item.title.toLowerCase().includes(searchTerm.toLowerCase());
            });
            setFilteredActivities(filteredActivitiesTemp);
            const filteredOffersTemp = offersRef.current.filter((item) => {
                const textWithoutTags = stripHtmlTags(item.text);
                return textWithoutTags.toLowerCase().includes(searchTerm.toLowerCase()) || item.title.toLowerCase().includes(searchTerm.toLowerCase());
            });
            setFilteredOffers(filteredOffersTemp);
            const filteredDirectoriesTemp = directoriesRef.current.filter((item) => {
                const textWithoutTags = stripHtmlTags(item.text);
                return textWithoutTags.toLowerCase().includes(searchTerm.toLowerCase()) || item.title.toLowerCase().includes(searchTerm.toLowerCase());
            });
            setFilteredDirectories(filteredDirectoriesTemp);
        }
        else {
            setFilteredActivities([]);
            setFilteredOffers([]);
            setFilteredDirectories([]);
        }
        setIsLoading(false);
    });
    const handleChange = (event) => {
        setSearchTerm(event.target.value);
        setIsLoading(true);
        debouncedRequest();
    };
    const navigationsType = navigations.homePage
        .map((navigation) => navigation)
        .filter((item) => item.type === "offers" ||
        item.type === "activities" ||
        item.type === "directory");
    const getItemsByType = (items, mainType) => {
        const title = getResourceTitle(navigationsType, mainType);
        if (!title) {
            return;
        }
        const isExpanded = searchTerm.length >= MIN_CHARACTER_LIMIT;
        return (react_1.default.createElement(material_1.Accordion, { key: (0, react_uid_1.uid)(items), expanded: isExpanded, onChange: () => { }, disabled: items.length === 0 || searchTerm.length < MIN_CHARACTER_LIMIT, disableGutters: true, sx: { boxShadow: "none" } },
            react_1.default.createElement(material_1.AccordionSummary, { expandIcon: react_1.default.createElement(ExpandMore_1.default, null), "aria-controls": "panel1a-content", sx: {
                    paddingLeft: 1,
                    paddingRight: 1,
                } },
                react_1.default.createElement(TypeName, null,
                    react_1.default.createElement(Typography_1.default, { variant: "caption", className: "accordion-title" },
                        title.toUpperCase(),
                        searchTerm.length >= MIN_CHARACTER_LIMIT &&
                            `( ${items.length} )`))),
            react_1.default.createElement(ListItemWrapper, null, mainType === "activities" ? (react_1.default.createElement(ActivitiSearchListItems_1.default, { contents: items })) : (items.map((item) => (react_1.default.createElement(SearchListItem_1.default, { key: (0, react_uid_1.uid)(item), content: item })))))));
    };
    const resultsPresent = searchTerm.length >= MIN_CHARACTER_LIMIT &&
        filteredActivities.length < 1 &&
        filteredOffers.length < 1 &&
        filteredDirectories.length < 1 ? (react_1.default.createElement(NoSearchResults, null,
        react_1.default.createElement("span", { className: "info-icon-wrapper" },
            react_1.default.createElement(Info_1.default, { className: "info-icon", sx: {
                    height: 40,
                    width: 40,
                } })),
        react_1.default.createElement("p", { className: "no-results-message" },
            i18n_js_1.default.t("no_information_found"),
            " ",
            react_1.default.createElement("strong", null,
                "\"",
                searchTerm,
                "\"")))) : (react_1.default.createElement(react_1.Fragment, null,
        getItemsByType(filteredActivities, "activities"),
        getItemsByType(filteredOffers, "offers"),
        getItemsByType(filteredDirectories, "directories")));
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(SearchWrapper, null,
            react_1.default.createElement(material_1.TextField, { id: "main-search-input", value: searchTerm, onChange: handleChange, role: "searchbox", variant: "standard", placeholder: collection
                    ? i18n_js_1.default.t("dictionary.search")
                    : i18n_js_1.default.t("search_bar_placeholder"), className: "text-field", InputProps: {
                    startAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "end" },
                        react_1.default.createElement(Search_1.default, null))),
                    endAdornment: (react_1.default.createElement(material_1.InputAdornment, { "data-testid": "clear-button", position: "end", onClick: () => {
                            onClose();
                        } },
                        react_1.default.createElement(Close_1.default, { className: "close-button" }))),
                } }),
            react_1.default.createElement(SearchResults, { className: "search-results" }, isLoading && searchTerm.length >= MIN_CHARACTER_LIMIT ? (react_1.default.createElement(Loader_1.default, null)) : (resultsPresent)))));
};
exports.Search = Search;
function getResourceTitle(navigations, mainType) {
    const activityNavigation = navigations.find((navigation) => navigation.type === "activities");
    if (mainType === "activities" && activityNavigation) {
        return activityNavigation.title
            ? activityNavigation.title
            : i18n_js_1.default.t("dictionary.activities.title");
    }
    const directoryNavigation = navigations.find((navigation) => navigation.type === "directory");
    if (mainType === "directories" && directoryNavigation) {
        return directoryNavigation.title
            ? directoryNavigation.title
            : i18n_js_1.default.t("tab_directorytab_services");
    }
    // offers
    const offersNavigation = navigations.find((navigation) => navigation.type === "offers");
    if (mainType === 'offers' && offersNavigation) {
        return offersNavigation.title
            ? offersNavigation.title
            : i18n_js_1.default.t("tab_services");
    }
    return null;
}
const mapStoreToProps = (store) => ({
    unfilteredActivities: store.getValue("unfilteredActivities"),
    directoryData: store.getValue("directory"),
    offers: store.getValue("offers"),
    navigations: store.getValue("navigations"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.Search));
